import {
  Form,
  Image,
  Input,
  Popconfirm,
  Typography,
  message,
  Button,
  Select,
} from "antd";
import React, { useState } from "react";
import AntTable from "../../components/AntTableV2";
import ApiWrapper from "../../utils/ApiWrapper";
const { Option } = Select;

const taxValues = ["0", "3", "5", "12", "18", "28"];
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "dropDown" ? (
      <Select style={{ width: 120 }}>
        {taxValues.map((val) => {
          return <Option value={val}>{`${val}%`}</Option>;
        })}
      </Select>
    ) : (
      <Input className=" h-6 w-full p-4" />
    );
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={restProps.form_name}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function InputProductTabV2(props) {
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState([...props.data]);
  const [editingKey, setEditingKey] = useState("");

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      costPerUnit: record.costPerUnit || "0",
      costPerUnitTax: record.costPerUnitTax || "0",
    });
    setEditingKey(record.key);
  };

  const cancel = () => {
    form.setFieldsValue({
      costPerUnit: "",
      costPerUnitTax: "",
    });
    setEditingKey("");
  };

  const save = async (record) => {
    try {
      const row = await form.validateFields();
      let changedRow = {
        listings: [
          {
            channel: record.channel,
            sku: record.sku,
            costPerUnit: row.costPerUnit,
            costPerUnitTax: row.costPerUnitTax,
            costPerUnitFromDate: props.taxStartDate
              ? props.taxStartDate.utc().format()
              : "",
            // costPerUnitToDate: props.taxStartDate[1],
          },
        ],
      };
      let reqData = {
                  updated_at: new Date(),
                  module_name: "InputProductCost",
                  updated_value: {
                    channel: record.channel,
                    sku: record.sku,
                    COGS: record.costPerUnit,
                    UpdatedCOGS: row.costPerUnit,
                    COGSTax: record.costPerUnitTax,
                    UpdatedCOGSTax: row.costPerUnitTax,
                    costPerUnitFromDate: props.taxStartDate
                      ? props.taxStartDate.utc().format()
                      : "",
                  },
                };
      let stateCopy = [record];

      setTableData(
        stateCopy.map((table) => {
          if (table.key === record.key) {
            return {
              ...table,
              costPerUnit: row.costPerUnit,
              costPerUnitTax: row.costPerUnitTax,
            };
          } else {
            return table;
          }
        })
      );
      setEditingKey("");
      // console.log(changedRow);
      // console.log(reqData);

      ApiWrapper("updateCostPerUnit", changedRow).then(
        function (response) {
          if (response.status) {
            let productListTmp = props.data.map((product) => {
              if (product.key === record.key) {
                product.costPerUnit = row.costPerUnit;
                product.costPerUnitTax = row.costPerUnitTax;
              }
              return product;
            });
            props.setInputProductData(productListTmp);
            message.warning(
              "Updating the order cost will take few minutes to reflect in Profitability."
            );
  
            ApiWrapper("updateChangeLog", reqData).then(
              function (response) {
                console.log(response);
              },
              function (error) {}
            );
          }
        },
        function (error) {}
      );
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const InputProductCost = [
    // {
    //   title: "Sno",
    //   align: "center",
    //   field: "channel",
    //   width: 80,
    //   editable: false,
    //   render: (record, rowIndex) => rowIndex,
    // },
    // {
    //   title: "Channel",
    //   align: "center",
    //   field: "channel",
    //   width: 80,
    //   editable: false,

    //   render: (record, rowIndex) =>
    //     record.channel === "Amazon-India" ? (
    //       <div className="amazon-logo-small"></div>
    //     ) : record.channel === "Flipkart" ? (
    //       <div className="flipkart-logo-small"></div>
    //     ) : (
    //       "-"
    //     ),
    //   isFilterable: true,
    //   type: "string",
    // },
    // {
    //   title: "Image",
    //   align: "center",
    //   field: "productId",
    //   width: 100,
    //   editable: false,

    //   render: (record, rowIndex) => (
    //     <Image
    //       // width={70}
    //       // height={70}
    //       style={{
    //         height: 36,
    //         width: 36,
    //         objectFit: "cover",
    //         border: "1px solid #EAE6FF",
    //       }}
    //       src={record.imageURL}
    //       fallback="data:image/png;base64,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"
    //     />
    //   ),
    // },

    {
      title: "Product ID",
      align: "center",
      isFilterable: true,
      ellipsis: true,
      editable: false,
      field: "productId",
      type: "string",
      defaultSortOrder: "descend",
      width: 160,
      render: (record, rowIndex, isLoading) => (
        <>
          {" "}
          <div
            className={`${
              record.channel === "Amazon-India"
                ? "amazon-logo-small"
                : record.channel === "Flipkart"
                ? "flipkart-logo-small"
                : null
            }`}
          />
          <div className="flex items-center justify-center">
            <Image
              width={36}
              height={36}
              src={record.imageURL}
              fallback="https://t4.ftcdn.net/jpg/02/07/87/79/360_F_207877921_BtG6ZKAVvtLyc5GWpBNEIlIxsffTtWkv.jpg"
            />
            <Button type="link">
              <a
                href={
                  record.channel === "Amazon-India"
                    ? `https://www.amazon.in/dp/${record.productId}`
                    : `https://flipkart.com/dl/Forcesight-flipkart-url-redirect/p/itmdzthskkpuquue?pid=${record.productId}`
                }
                target="_blank"
                rel="noreferrer"
              >
                {record.productId || ""}
              </a>
            </Button>
          </div>
        </>
      ),
      sorter: (a, b) => {
        a = (a.productId || "").toLowerCase();
        b = (b.productId || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
      // render: (record, rowIndex) => "-"
    },
    {
      title: "Name",
      align: "center",
      isFilter: true,
      field: "name",
      ellipsis: true,
      editable: false,
      isFilterable: true,
      isSearchable: true,
      type: "string",
      width: 140,
      render: (record, rowIndex) => record.name || "", //.replace(/(.{20})..+/, "$1…"),
      sorter: (a, b) => {
        a = (a.name || "").toLowerCase();
        b = (b.name || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Marketplace SKU",
      align: "center",
      field: "sku",
      type: "string",
      editable: false,
      isFilterable: true,
      isEditable: true,
      width: 100,
      render: (record, rowIndex, isLoading) => (record.sku ? record.sku : "-"),
      searchPriority: 5,
      onSearch: (searchText) => (data) =>
        (data || "").toLowerCase().includes(searchText.toLowerCase()),
      editable: false,
      sorter: (a, b) => {
        a = (a.sku || "").toLowerCase();
        b = (b.sku || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },

    {
      title: "Selling Price",
      align: "center",
      isFilterable: true,
      editable: false,
      isTotal: true,
      field: "price",
      type: "number",
      width: 100,
      sorter: (a, b) => {
        a = (a || {}).price || 0;
        b = (b || {}).price || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
      // render: (record, rowIndex) => "-"
    },
    {
      title: "Cost Per Unit",
      align: "center",
      isFilterable: true,
      isTotal: true,
      field: "costPerUnit",
      type: "number",
      form_name: "costPerUnit",
      editable: true,
      width: 100,
      sorter: (a, b) => {
        a = (a || {}).costPerUnit || 0;
        b = (b || {}).costPerUnit || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Unit Tax",
      align: "center",
      isFilterable: true,
      isTotal: true,
      field: "costPerUnitTax",
      type: "number",
      form_name: "costPerUnitTax",
      editable: true,
      width: 100,
      sorter: (a, b) => {
        a = (a || {}).costPerUnit || 0;
        b = (b || {}).costPerUnit || 0;
        return a - b;
      },
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "",
      align: "center",
      field: "",
      width: 60,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record)}
              style={{
                marginRight: 8,
              }}
            >
              Save
            </Typography.Link>
            <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
              <a>Cancel</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          >
            Edit
          </Typography.Link>
        );
      },
    },
  ];

  const mergedColumns = InputProductCost.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.form_name === "costPerUnitTax" ? "dropDown" : "number",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: editingKey === record.key,
        form_name: col.form_name || "",
      }),
    };
  });
  const onTableChange = async ({
    paginationCondition,
    sortCondition,
    filterCondition,
  }) => {
    props.tableFilterData(paginationCondition, sortCondition, filterCondition);
  };
  React.useEffect(() => {
    if (props.activeTab === "4") {
      props.setColumn(InputProductCost);
    }
  }, [props.activeTab]);
  return (
    <div>
      <Form form={form} component={false}>
        <AntTable
          components={{
            body: {
              cell: EditableCell,
            },
          }}
          columns={mergedColumns}
          dataSource={props.data}
          stickyHeader={{
            offsetHeader: 65,
          }}
          rowKey={(row, rowIndex) => rowIndex}
          isLoading={props.isLoading}
          hideSummary={true} //!props.data?.length}
          searchText={[props.searchText]}
          totalRecords={props.pageCount}
          onDataChange={onTableChange}
        />
      </Form>
    </div>
  );
}
